import { render, staticRenderFns } from "./FacebookDeleteStatus.vue?vue&type=template&id=577ca76e&scoped=true"
import script from "./FacebookDeleteStatus.vue?vue&type=script&lang=js"
export * from "./FacebookDeleteStatus.vue?vue&type=script&lang=js"
import style0 from "./FacebookDeleteStatus.vue?vue&type=style&index=0&id=577ca76e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ca76e",
  null
  
)

export default component.exports